import React from "react";
import { query_string } from "./queries";

const debug = query_string("debug");

type ChangeCallback = (x: boolean) => void;

interface MyCheckboxProps {
    id: string;
    className?: string;

    enabledStyle?: Object;
    disabledStyle?: Object;
    hoverStyle?: Object;
    focusStyle?: Object;
    errorStyle?: Object;

    onChange?: ChangeCallback,
}

function MyCheckbox(props: MyCheckboxProps) {
    const inputRef = React.useRef(null);
    const [style, setStyle] = React.useState({});
    const [enabledStyle, setEnabledStyle] = React.useState({});
    const [focusStyle, setFocusStyle] = React.useState({});
    const [changeCallback, setChangeCallback] = React.useState(() => {
        return props.onChange || ((_: boolean) => {
            console.log(`change not defined`);
        });
    });
    const [checked, setChecked] = React.useState(false);

    React.useEffect(() => {
        console.log(`${checked}, %o`, changeCallback)
        if (changeCallback) {
            changeCallback(checked);
        }
    }, [checked, changeCallback]);

    React.useEffect(() => {
        if (props.enabledStyle) {
            setEnabledStyle(props.enabledStyle);
            // console.log(`enabled: %o`, props.enabledStyle);
        }
        if (props.focusStyle) {
            setFocusStyle(props.focusStyle);
            // console.log(`focus: %o`, props.focusStyle);
        }
        const newChangeCallback = props.onChange;
        if (newChangeCallback) {
            // console.log(`on-change: %o`, newChangeCallback);
            // setChangeCallback(newChangeCallback);
        }
    }, [props.enabledStyle, props.focusStyle, props.onChange]);

    React.useEffect(() => {
        let input: HTMLInputElement|null = null;
        if (inputRef.current) {
            input = inputRef.current as HTMLInputElement;
            if (input.checked)
                setStyle(enabledStyle);
            else
                setStyle(focusStyle);
        }
    }, [enabledStyle, focusStyle])
   
    const onClick = (_evt: React.MouseEvent<HTMLDivElement>) => {
        if (inputRef.current) {
            let input = inputRef.current as HTMLInputElement;
            input.checked = !input.checked;
            if (input.checked)
                setStyle(enabledStyle);
            else
                setStyle(focusStyle);
            setChecked(input.checked);
        }
    }

    return <>
        <input type="checkbox"
            ref={inputRef}
            id={props.id}
            className={props.className}
            checked={checked}
        />
        <div onClick={onClick} style={style}></div>
    </>
}

export default MyCheckbox;
